// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cUSjqXwjp44dGjJD_B7q{align-items:center;gap:12px;display:flex}.R1Ccun8xOIvPsb8gKdF9{--background-neutral-default:var(--background-primary-inverted-primary);background:var(--black-10);border-radius:10px;padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `cUSjqXwjp44dGjJD_B7q`,
	"tabs": `R1Ccun8xOIvPsb8gKdF9`
};
export default ___CSS_LOADER_EXPORT___;
